"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPI = void 0;
class BaseAPI {
    constructor(requester) {
        this.requester = requester;
    }
    getEndpoint(...endpoints) { return this.path + '/' + endpoints.join('/'); }
}
exports.BaseAPI = BaseAPI;
